import React from "react";
import Toolbar from "@mui/material/Toolbar";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import { Box, Stack, useTheme } from "@mui/material";

import logoLight from "../../../utils/assets/logoLight.png";
import logoDark from "../../../utils/assets/logoMobileDark.png";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));
export interface MenuAppBarProps {
 
}

export default function MenuAppBar(props: MenuAppBarProps) {
  const theme = useTheme();
  
  return (
    <React.Fragment>
      <ThemeProvider
        theme={createTheme({
          components: {
            MuiListItemButton: {
              defaultProps: {
                disableTouchRipple: true,
              },
            },
          },
          palette: {
            mode: theme.palette.mode,
            primary: { main: "rgb(255, 255, 255)" },
            background: {
              paper:
                theme.palette.mode === "dark"
                  ? "rgb(37, 37, 38)"
                  : "rgb(255, 255, 255)",
            },
          },
        })}
      >
        <AppBar elevation={0} position="fixed" sx={{ backgroundImage: "none" }}>
          <Toolbar>
            <Box
              sx={{
                flexGrow: 1,
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Box
                  component="img"
                  src={theme.palette.mode === "dark" ? logoDark : logoLight}
                  alt="Arcos"
                  height="47px"
                />
              </Stack>
            </Box>            
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </React.Fragment>
  );
}
